export default __webpack_public_path__ + "static/media/Delivery-Man.b89ac72f.jpg";